import React from 'react';
import ReactToolTip from 'react-tooltip';
import {removeLeadingAndTrailingQuotations} from "../../../../../utils/string";
import {STYLE_RECORDING_CARD_INFO_ITEM} from "../RecordingCard";
import {PRIVACY_PRIVATE, PRIVACY_PUBLIC} from "../../../../recording/utils";

const TOOLTIP_PUBLIC_ID = "privacyPublicTip";
const TOOLTIP_PRIVATE_ID = "privacyPrivateTip";

/**
 * A component that is displayed for a public recording card
 */
const PublicPrivacy = () => {
    return (
        <div style={STYLE_RECORDING_CARD_INFO_ITEM}>
            <div data-tip data-for={TOOLTIP_PUBLIC_ID}>
                <i className="fas fa-globe" /> Public
            </div>
            <ReactToolTip id={TOOLTIP_PUBLIC_ID}>
                <span>Public. Anyone who has access to the link can view it.</span>
            </ReactToolTip>
        </div>
    );
};

/**
 * A component that is displayed for a private recording card
 */
const PrivatePrivacy = () => {
    return (
        <div style={STYLE_RECORDING_CARD_INFO_ITEM}>
            <div data-tip data-for={TOOLTIP_PRIVATE_ID}>
                <i className="fas fa-lock" /> Private
            </div>
            <ReactToolTip id={TOOLTIP_PRIVATE_ID}>
                <span>Private. Only you can view this recording.</span>
            </ReactToolTip>
        </div>
    );
};

/**
 * A component returns the appropriate component
 * depending on the privacy level {@code rawPrivacy}.
 */
const PrivacyLevels = ({rawPrivacy}) => {
    if (rawPrivacy) {
        const privacy = removeLeadingAndTrailingQuotations(rawPrivacy);
        if (privacy === PRIVACY_PUBLIC) {
            return <PublicPrivacy/>;
        } else if (privacy === PRIVACY_PRIVATE) {
            return <PrivatePrivacy/>;
        }
    }
    return <PrivatePrivacy/>;
};

export default PrivacyLevels;



// WEBPACK FOOTER //
// ./src/components/unit/recordings/recordingcard/information/PrivacyLevels.jsx